//公共
export const COM_LOADING = 'COM_LOADING';

export const STAFF_LIST = 'STAFF_LIST';

export const MSG_LIST = 'MSG_LIST';

export const ROLE_LIST = 'ROLE_LIST';

export const SYSTEM_TIME = 'SYSTEM_TIME';

export const SYSTEM_DATE = 'SYSTEM_DATE';

export const PRIORITY_LIST = 'PRIORITY_LIST'; // 优先级列表

export const STATUS_LIST = 'STATUS_LIST'; //状态列表

export const EDUCATION_LIST = 'EDUCATION_LIST'; //状态列表

// 登录
export const LOG_GETUSERINFO = 'LOG_GETUSERINFO';
export const LOG_GETAVATAR = 'LOG_GETAVATAR';
export const LOGINING = 'LOGINING';

//首页
export const INDEX_COLLAPSE = 'INDEX_COLLAPSE';

//菜单相关信息
export const MENU_ID = 'MENU_ID';
export const MENU_AUTH = 'MENU_AUTH';

// 订单Drawer 显示隐藏Visible
export const INDEX_ORDERDRAWERVISIBLE = 'INDEX_ORDERDRAWERVISIBLE';

// 网址URL 绝对路径
export const WWWURL = 'WWWURL';

export const DEPART_USER_LIST = 'DEPART_USER_LIST';

export const DEPART_SELECT_USER = 'DEPART_SELECT_USER';

// tags显示隐藏
export const IS_INFOTAGS = 'IS_INFOTAGS';